import pl from "../lang/pl";
import en from "../lang/en";

export function translate(string) {
    const lang = {
        "pl" : pl,
        "en" : en
    };
    const curr = (this.$route.meta.lang) ? this.$route.meta.lang : "pl";

    return lang[curr][string] || string;
};